import header from "./development-plan-on-tablet.png";
import section1 from "./digitaler-wegeplan.png";
import section2 from "./weg-on-tablet.png";
import section3 from "./fluransicht-von-oben.jpg";
import section4 from "./hausansicht-von-vorne.png";
import section5 from "./flurplan-von-oben.jpg";
import section6 from "./mehrfamilienhaus.png";
import section7 from "./digitaler-grundriss-ausgedruckt.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
